// src/app/services/map.service.ts
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';

export interface IpPoint {
  ip: string;
  latitude: number;
  longitude: number;
  count: number;
}

@Injectable({ providedIn: 'root' })
export class MapService {

  // Sólo mock si aún no tienes el API
  private mockPoints: IpPoint[] = [
    { ip: '203.0.113.5', latitude: 40.4168, longitude: -3.7038, count: 12 },
    { ip: '198.51.100.23', latitude: 51.5074, longitude: -0.1278, count: 8 },
    { ip: '192.0.2.45',   latitude: 40.7128, longitude: -74.0060, count: 5 },
  ];

  constructor(private http?: HttpClient) {}

  /**
   * Si tienes un endpoint real, descomenta el bloque HTTP y comenta el `of(...)`
   */
  getIpPoints(
    element: string = 'pixels',
    start?: string,   // 'YYYY-MM-DD'
    end?: string      // 'YYYY-MM-DD'
  ): Observable<IpPoint[]> {
    if (this.http) {
      let params = new HttpParams().set('element', element);
      if (start) params = params.set('start', start);
      if (end)   params = params.set('end', end);
      return this.http.get<IpPoint[]>('/api/map/ips', { params });
    } else {
      // simulación de filtrado local (solo por elemento)
      return of(
        this.mockPoints
          .filter(p => element === 'pixels' || p.ip.includes(element))
      );
    }
  }
}
